export const NEARBY_STORES_PREFIX = "NearbyStores";

export const NEARBY_STORES_CLASSES = {
  title: `${NEARBY_STORES_PREFIX}-title`,
  cards: `${NEARBY_STORES_PREFIX}-cards`,
  hideOnMobile: `${NEARBY_STORES_PREFIX}-hideOnMobile`,
};
